import React from 'react';
import { get, post, put, del, patch } from '../../../../Utility/Http';
import { loginDetailsListingGet } from '../Model/LoginActivityModel';
import Config from '../../../../Utility/Config';

export const loginDetailsListing = (data) => {
    return get(`${Config.extendedUrl}admin/user_login_activities`, data).then((response) => {
        return loginDetailsListingGet(response)
    });
};